import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../cn';

export type GridProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const Grid = ({ className, children, ...props }: GridProps) => (
  <div className={cn('grid-12', className)} {...props}>
    {children}
  </div>
);
